export class ReceiptLayout {
    constructor(props) {
        this.blockLines = [];
        Object.assign(this, props);
        this.blockLines.push(new BlockBarCode(Align.Center, BarCodeType.QRCode));
        this.blockLines.push(new BlockBarCode(Align.Center, BarCodeType.QRCode));
    }
}
class Block {
    constructor(align) {
        this.align = align;
    }
}
export class BlockText extends Block {
    constructor(props) {
        super(props.align);
        // Object.assign(this, props)
        this.fontSize = props.fonSize;
        this.text = props.text;
    }
}
export class Separator extends Block {
    constructor(value) {
        super(Align.Center);
        if (value.length > 1 || value.length === 0) {
            throw new Error('only one character');
        }
    }
}
export class BlockBarCode extends Block {
    constructor(align, type) {
        super(align);
        this.type = type;
    }
}
export var Align;
(function (Align) {
    Align["Left"] = "left";
    Align["Center"] = "center";
    Align["Right"] = "right";
})(Align || (Align = {}));
export const widthPaper = 80;
export var FontSize;
(function (FontSize) {
    FontSize[FontSize["smaller"] = widthPaper === 80 ? 10 : 7] = "smaller";
    FontSize[FontSize["small"] = widthPaper === 80 ? 12 : 8] = "small";
    FontSize[FontSize["normal"] = widthPaper === 80 ? 15 : 10] = "normal";
    FontSize[FontSize["big"] = widthPaper === 80 ? 25 : 22] = "big";
    FontSize[FontSize["bigger"] = widthPaper === 80 ? 27 : 25] = "bigger";
    FontSize[FontSize["biggest"] = widthPaper === 80 ? 29 : 27] = "biggest";
    FontSize[FontSize["extraBiggest"] = widthPaper === 80 ? 31 : 29] = "extraBiggest";
})(FontSize || (FontSize = {}));
export var FontAtt;
(function (FontAtt) {
    FontAtt["Normal"] = "normal";
    FontAtt["Bold"] = "bold";
    FontAtt["Cursiva"] = "cursiva";
})(FontAtt || (FontAtt = {}));
export var BarCodeType;
(function (BarCodeType) {
    BarCodeType["QRCode"] = "qrCode";
    BarCodeType["Code_128"] = "code128";
    BarCodeType["Code_39"] = "code39";
})(BarCodeType || (BarCodeType = {}));
export var Placeholders;
(function (Placeholders) {
    Placeholders["firstName"] = "${firstName}";
    Placeholders["lastName"] = "${lastName}";
    Placeholders["staffId"] = "${staffId}";
    Placeholders["date"] = "${date}";
    Placeholders["time"] = "${time}";
    Placeholders["waypoint"] = "${waypoint}";
    Placeholders["validUntil"] = "${validUntil}";
    Placeholders["validFor"] = "${validFor}";
    Placeholders["eventDate"] = "${eventDate}";
    Placeholders["eventTime"] = "${eventTime}";
    Placeholders["account"] = "${account}";
    Placeholders["ticketNumber"] = "${ticketNumber}";
    Placeholders["receiptNumber"] = "${receiptNumber}";
})(Placeholders || (Placeholders = {}));



//////////////////
// WEBPACK FOOTER
// ./src/modules/ReceiptLayouts/Model.ts
// module id = 28
// module chunks = 0